import { render, staticRenderFns } from "./face-to-face-cmp.vue?vue&type=template&id=392d16df&scoped=true"
import script from "./face-to-face-cmp.vue?vue&type=script&lang=js"
export * from "./face-to-face-cmp.vue?vue&type=script&lang=js"
import style0 from "./face-to-face-cmp.vue?vue&type=style&index=0&id=392d16df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d16df",
  null
  
)

export default component.exports